import { PublicClientApplication } from '@azure/msal-browser'

type MsalConfigInput = {
  msalClientId?: string | null
  msalAuthority?: string | null
  msalRedirectUri?: string | null
}

export const createMsal = (config: MsalConfigInput) => {
  if (
    !config?.msalAuthority ||
    !config?.msalClientId ||
    !config?.msalRedirectUri
  ) {
    return {
      hasSSO: false,
    }
  }

  const msalConfig = {
    auth: {
      clientId: config.msalClientId,
      authority: `https://login.microsoftonline.com/${config.msalAuthority}`,
      redirectUri: config.msalRedirectUri,
    },
  }

  const msalInstance = new PublicClientApplication(msalConfig)
  return {
    msalInstance,
    hasSSO: true,
  }
}
